import { createReducer, on } from '@ngrx/store';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { OrganizationPart } from './organization-part.model';
import * as OrganizationPartActions from './organization-part.actions';

export interface OrganizationPartState extends EntityState<OrganizationPart> {
    selectedOrganizationPartId: number | null;
    loading: boolean;
    error: string | null;
}

export const adapter: EntityAdapter<OrganizationPart> = createEntityAdapter<OrganizationPart>({
    selectId: (organizationPart: OrganizationPart) => organizationPart.id,
    sortComparer: false
});

export const initialState: OrganizationPartState = adapter.getInitialState({
    selectedOrganizationPartId: null,
    loading: false,
    error: null
});

export const organizationPartReducer = createReducer(
    initialState,
    on(OrganizationPartActions.fetchOrganizationParts, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(OrganizationPartActions.fetchOrganizationPartsSuccess, (state, { organizationParts }) =>
        adapter.setAll(organizationParts, {
            ...state,
            loading: false
        })
    ),
    on(OrganizationPartActions.fetchOrganizationPartsFailed, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.message
    })),
    on(OrganizationPartActions.selectOrganizationPart, (state, { organizationPartId }) => ({
        ...state,
        selectedOrganizationPartId: parseInt(organizationPartId, 10)
    })),
    on(OrganizationPartActions.upsertOrganizationParts, (state, { organizationParts }) =>
        adapter.upsertMany(organizationParts, state)
    ),
    on(OrganizationPartActions.fetchOrganizationPartsByIds, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    on(OrganizationPartActions.fetchOrganizationPartsByIdsSuccess, (state, { organizationParts }) =>
        adapter.upsertMany(organizationParts, {
            ...state,
            loading: false
        })
    ),
    on(OrganizationPartActions.fetchOrganizationPartsByIdsFailed, (state, { error }) => ({
        ...state,
        loading: false,
        error: error.message
    }))
);
